export default {
    topics: [
        {
            title: ' Validation ',
            href: 'sm-localValidationLog-Validation.html',
            attributes: { 'data-id': 'sm-localValidationLog-Validation' },
            menu: { hasChildren: false },
            tocID: 'sm-localValidationLog-Validation-d66e3157',
            topics: [],
        },
    ],
};

